import Vue from 'vue'
import Router from 'vue-router'
import Colors from '@/components/Colors'
import Buttons from '@/components/Buttons'
import Iconography from '@/components/Iconography'
import Typography from '@/components/Typography'
import Logos from '@/components/Logos'
import Notification from '@/components/Notification'
import Checkbox from '@/components/Checkbox'
import RadioButton from '@/components/RadioButton'
import Modals from '@/components/Modals'
import Confirm from '@/components/Confirm'
import Breadcrumbs from '@/components/Breadcrumbs'
import Input from '@/components/Input'
import Select from '@/components/Select'

Vue.use(Router)


export default new Router({
  //mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Logos
    },
    {
      path: '/logos',
      name: 'Logos',
      component: Logos
    },
    {
      path: '/colors',
      name: 'Colors',
      component: Colors
    },
    {
      path: '/iconography',
      name: 'Iconography',
      component: Iconography
    },
    {
      path: '/typography',
      name: 'Typography',
      component: Typography
    },
    {
      path: '/buttons',
      name: 'Buttons',
      component: Buttons
    },
    {
      path: '/notification',
      name: 'Notification',
      component: Notification
    },
    {
      path: '/checkbox',
      name: 'Checkbox',
      component: Checkbox
    },
    {
      path: '/radiobutton',
      name: 'Radiobutton',
      component: RadioButton
    },
    {
      path: '/modals',
      name: 'Modals',
      component: Modals
    },
    {
      path: '/confirm',
      name: 'Confirm',
      component: Confirm
    },
    {
      path: '/breadcrumbs',
      name: 'Breadcrumbs',
      component: Breadcrumbs
    },
    {
      path: '/input',
      name: 'Input',
      component: Input
    },
    {
      path: '/select',
      name: 'Select',
      component: Select
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js